import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_4203_18264)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = { id: "clip0_4203_18264" }
const _hoisted_7 = ["width", "height"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'penIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  size: {
    type: Number as PropType<number>,
    default: 18,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M11.2249 0.999613C10.9932 0.770007 10.695 0.619343 10.3727 0.56907C10.0505 0.518797 9.72053 0.571478 9.42993 0.719613C9.42993 0.719613 9.40493 0.669613 9.37993 0.649613L9.19993 0.449613C8.91124 0.16169 8.52015 0 8.11243 0C7.7047 0 7.31362 0.16169 7.02493 0.449613L4.28993 3.18461C4.1968 3.27829 4.14453 3.40502 4.14453 3.53711C4.14453 3.66921 4.1968 3.79593 4.28993 3.88961C4.33641 3.93648 4.39171 3.97367 4.45264 3.99906C4.51357 4.02444 4.57892 4.03751 4.64493 4.03751C4.71093 4.03751 4.77629 4.02444 4.83722 3.99906C4.89815 3.97367 4.95345 3.93648 4.99993 3.88961L7.73493 1.15461C7.83582 1.05597 7.97132 1.00074 8.11243 1.00074C8.25353 1.00074 8.38903 1.05597 8.48993 1.15461L8.67493 1.33961L7.55993 2.44961C7.51167 2.4991 7.48466 2.56549 7.48466 2.63461C7.48466 2.70374 7.51167 2.77012 7.55993 2.81961L9.39493 4.64961C9.41831 4.67459 9.44658 4.6945 9.47797 4.70811C9.50936 4.72173 9.54321 4.72875 9.57743 4.72875C9.61164 4.72875 9.6455 4.72173 9.67689 4.70811C9.70828 4.6945 9.73654 4.67459 9.75993 4.64961L11.2249 3.18461C11.5135 2.89422 11.6754 2.50148 11.6754 2.09211C11.6754 1.68275 11.5135 1.29 11.2249 0.999613Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M6.99958 3.36974C6.95093 3.3218 6.88537 3.29492 6.81708 3.29492C6.74878 3.29492 6.68322 3.3218 6.63458 3.36974L2.52958 7.49974C2.38544 7.64652 2.30469 7.84402 2.30469 8.04974C2.30469 8.25545 2.38544 8.45295 2.52958 8.59974L3.62958 9.69474C3.70161 9.7673 3.7873 9.82489 3.88169 9.86419C3.97609 9.90349 4.07733 9.92373 4.17958 9.92373C4.28183 9.92373 4.38306 9.90349 4.47746 9.86419C4.57185 9.82489 4.65754 9.7673 4.72958 9.69474L8.84458 5.58474C8.89283 5.53525 8.91984 5.46886 8.91984 5.39974C8.91984 5.33061 8.89283 5.26423 8.84458 5.21474L6.99958 3.36974Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M1.71563 8.87944C1.68758 8.85225 1.65342 8.83216 1.61602 8.82085C1.57862 8.80955 1.53906 8.80735 1.50063 8.81444C1.45957 8.82196 1.42124 8.84028 1.38961 8.86753C1.35797 8.89477 1.33416 8.92995 1.32063 8.96944L0.335634 11.6644C0.319431 11.7086 0.315997 11.7564 0.325725 11.8024C0.335453 11.8483 0.35795 11.8907 0.390634 11.9244C0.424977 11.9579 0.467905 11.9812 0.514673 11.9918C0.56144 12.0024 0.610225 11.9999 0.655634 11.9844L3.34563 10.9994C3.38224 10.9854 3.41519 10.9633 3.44203 10.9347C3.46888 10.9061 3.48891 10.8719 3.50063 10.8344C3.51076 10.793 3.5101 10.7496 3.49873 10.7085C3.48735 10.6673 3.46563 10.6298 3.43563 10.5994L1.71563 8.87944Z",
        fill: __props.color
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", _hoisted_6, [
        _createElementVNode("rect", {
          width: __props.size,
          height: __props.size,
          fill: "white"
        }, null, 8, _hoisted_7)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})